import { Button, Form, Input } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLoading } from "../../context/LoadingContext";
import { InputRequired } from "../../validations/validations";
import CustomPassword from "../CustomPassword";
import { P3 } from "../NormalFonts";
import { LoginFormType } from "./data";
import styles from "./styles.module.scss";
const LoginForm: React.FC<LoginFormType> = ({ onFinish, onForgetPassword }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { setIsLoading } = useLoading();
  const navigate = useNavigate();
  const { setRegisterForm, loading } = useAuth();
  const handleOpenRegisterPage = () => {
    setRegisterForm();
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  return (
    // <div className={styles.container}>
    <Form
      className={styles.container}
      autoComplete={"off"}
      onFinish={onFinish}
      form={form}
      requiredMark={false}
      layout={"vertical"}
    >
      <Form.Item name={"account"} label={t("auth.input.email")}>
        <Input placeholder={t("auth.hint.email")} />
      </Form.Item>
      <Form.Item
        name={"password"}
        label={t("auth.input.password")}
        rules={[
          InputRequired(t, "auth.input.password"),
          // PasswordFormat(t, 6, 20),
        ]}
      >
        <CustomPassword placeholder={t("auth.hint.password")} />
      </Form.Item>
      <Button
        className={styles.forgetButton}
        size={"small"}
        type={"link"}
        onClick={onForgetPassword}
      >
        {t("normal.forgotpassword")}
      </Button>
      <Button type={"primary"} htmlType={"submit"} block>
        {t("normal.login")}
      </Button>
      <div className={styles.footer}>
        <P3>{t("auth.login.toregister.title")}</P3>
        <Button type="link" size="small" onClick={handleOpenRegisterPage}>
          {t("normal.register")}
        </Button>
      </div>
    </Form>
    // </div>
  );
};

export default LoginForm;
